import {
    SEO_TITLE_STROLLER_WISHLIST,
    STROLLER_SEO_GENERAL_DESC, STROLLER_SEO_WISHLIST,
    STROLLER_WISHLIST_TITLE,
} from 'mk/autogenerated/translations/WishListPage.e4cb4064db9eeecdb80dc9bf89a23b41'
import { toastAdd } from 'mk2/actions';
import WishList from 'mk2/apps/strollers/containers/WishList/WishList';
import {
    strollersWishlistIdsLoad,
    strollersWishlistItemsFetchTrigger,
    strollersWishlistToggle,
} from 'mk2/apps/strollers/containers/WishList/WishList.actions';
import wishListReducer from 'mk2/apps/strollers/containers/WishList/WishList.reducers';
import wishListSaga from 'mk2/apps/strollers/containers/WishList/WishList.sagas';
import {
    getStrollersWishListItems,
    getStrollersWishListState,
} from 'mk2/apps/strollers/containers/WishList/WishList.selectors';
import { StrollerEntity } from 'mk2/apps/strollers/schemas';
import { strollersUrl } from 'mk2/apps/strollers/urls';
import ServerErrorToast from 'mk2/components/toasts/ServerErrorToast';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { HalfpageProps } from 'mk2/pages/Page';
import { AppState, getResponseRenderedAt } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
}

interface StateProps {
    items: StrollerEntity[];
    hasMore: boolean;
    loadingState: LoadingState;
    errorMessage: string;
    renderedAt: number;
    wishlist: any;
}

interface DispatchProps {
    onLoad(after?: string);
    onWishlistLoad();
    onWishlistToggle(strollerId);

    onFailureToast();
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class WishListPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {

            const wishListState = getStrollersWishListState(state);

            return {
                errorMessage: wishListState.errorMessage,
                loadingState: wishListState.loadingState,
                items: getStrollersWishListItems(state),
                hasMore: wishListState.hasMore,
                renderedAt: getResponseRenderedAt(state),
                wishlist: wishListState.currentWishlist,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: strollersWishlistItemsFetchTrigger,
            onWishlistToggle: strollersWishlistToggle,
            onWishlistLoad: strollersWishlistIdsLoad,
            onFailureToast: () => toastAdd('error', {
                component: ServerErrorToast,
            }),
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_STROLLER_WISHLIST;
    }

    public getMetaDescription(props: Props): string {
        return `${STROLLER_SEO_WISHLIST} - ${STROLLER_SEO_GENERAL_DESC}`;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <WishList {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return strollersUrl;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return {
            zone: 'Strollers Index - Halfpage Sticky (Desktop)',
        };
    }

    public getHeaderTitle(props: Props): string {
        return STROLLER_WISHLIST_TITLE;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.strollers.wishList', wishListReducer);
        store.injectSaga('containers.strollers.wishList', wishListSaga);
    }

}
